import { createClient } from '@supabase/supabase-js';

// ─── Supabase configuration ─────────────────────────────────────────────────
// These values are read from environment variables.
// Create a .env.local file in the project root with:
//   REACT_APP_SUPABASE_URL=https://your-project.supabase.co
//   REACT_APP_SUPABASE_ANON_KEY=your-anon-key
// For Vercel, add these as Environment Variables in the project settings.
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;
// ────────────────────────────────────────────────────────────────────────────

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Admin emails — add the email(s) that should see the admin dashboard
export const ADMIN_EMAILS = [
  'brett@campphillip.com',
  'matthew@campphillip.com',
  'eli@campphillip.com',
  'justin@campphillip.com',
  'hannah@campphillip.com',
  'juniorstaffdirector@campphillip.com',
  'jess@campphillip.com',
  // add more as needed
];

export const isAdmin = (email) => ADMIN_EMAILS.includes(email?.toLowerCase());
